import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ListaCartoesPageComponent } from './lista-cartoes-page/lista-cartoes-page.component';
import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from '../shared/components/components.module';
import { MaterialAngularModule } from '../material-design/material.module';
import { PropostasPageComponent } from './propostas-page/propostas-page.component';
import { FormsModule } from '@angular/forms';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { AceitarTermosComponent } from './aceitar-termos/aceitar-termos.component';
import { InformacoesCartaoComponent } from './renegociacao-components/InformacoesCartao/informacoes-cartao.component';
import { InformacoesPropostaComponent } from './renegociacao-components/informacoes-proposta/informacoes-proposta.component';
import { CheckoutPageComponent } from './checkout-page/checkout-page.component';
import { CurrencyMaskPipe } from '../shared/pipes/currency-mask.pipe';
import { AcompanharAcordoPageComponent } from './acompanhar-acordo-page/acompanhar-acordo-page.component';
import { AcordoTableComponent } from './acompanhar-acordo-page/acordo-table/acordo-table.component';

@NgModule({
  declarations: [
    ListaCartoesPageComponent,
    PropostasPageComponent,
    AceitarTermosComponent,
    InformacoesCartaoComponent,
    InformacoesPropostaComponent,
    CheckoutPageComponent,
    AcompanharAcordoPageComponent,
    AcordoTableComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ComponentsModule,
    MaterialAngularModule,
    FormsModule,
    SharedPipesModule
  ],
  providers: [DatePipe, CurrencyMaskPipe],
})
export class RenegociacaoCartaoModule { }
